export const isPrimitive = (test) => test !== Object(test);

export const debounce = (func, wait, immediate) => {
    let timeout;

    return function executedFunction() {
        const context = this;
        const args = arguments;

        const later = function() {
            timeout = null;
            
            if (!immediate) {
                func.apply(context, args);
            }
        };

        const callNow = immediate && !timeout;

        clearTimeout(timeout);

        timeout = setTimeout(later, wait);

        if (callNow) {
            func.apply(context, args);
        }
    }
}

export const throttle = (callback, interval) => {
    let enableCall = true;
  
    return function(...args) {
      if (!enableCall) return;
  
      enableCall = false;
      callback.apply(this, args);
      setTimeout(() => enableCall = true, interval);
    }
};

export const groupBy = (key, array) => {
    return array.reduce((objectsByKeyValue, obj) => {
        const value = obj[key];

        objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
        
        return objectsByKeyValue;
    }, {});
}

export const mergeArrsByKey = (newArr, oldArr, key) => {
    const mergedArray = [...newArr, ...oldArr];
    
    const set = new Set();

    return mergedArray.filter((item) => {
        if (!set.has(item[key])) {
            set.add(item[key]);
            return true;
        }

        return false;
    }, set);
}

export const declOfNum = (number, titles) => {
    const cases = [2, 0, 1, 1, 1, 2];
    return titles[ (number%100>4 && number%100<20)? 2 : cases[(number%10<5)?number%10:5] ];
}

export const getFullUrl = (uri) => {
    return (!process.env.NODE_ENV || process.env.NODE_ENV === 'development' ? 'http://localhost:8000/' : '/') + (uri ?? '')
}